import React from 'react';
import './RoundButtonIcon.scss';
import { Button, Icon } from '@ampol/design-system';

/**
 * A round button component
 * @param plusIcon Plus icon if true, otherwise minus icon
 * @param buttonColor Colour of the button
 * @param iconColor Colour of the icon
 * @param inactive Set button inactive
 * @param onClick onClick action
 * @returns JSX Element
 */

const RoundButtonIcon = ( { plusIcon, buttonColor, type, formId, iconColor, inactive, onClick, alt }) => {
  return <>
    <Button 
      label=''
      variant='primary'
      color={buttonColor}
      type={type}
      formId={formId}
      onClick={onClick}
      inactive={inactive}
      className={'button'}
      iconPrefix={<Icon url={plusIcon ? '/icons/plus.svg' : '/icons/minus.svg'} size={12} className={`button__icon button__icon--${iconColor}`} alt={alt} /> }
    />
  </>;

};

export default RoundButtonIcon;
